import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { id: "vat-tu-bien-ban-table" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  class: "text-end",
  rowspan: "2"
}, "TT", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  class: "text-end",
  rowspan: "2"
}, "ID", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Mã số", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  class: "text-start ps-2",
  rowspan: "2",
  style: {"width":"6rem"}
}, "ĐVT", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-end pe-2",
  rowspan: "2",
  style: {"width":"8rem"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  class: "text-end pe-2",
  rowspan: "2",
  style: {"width":"8rem"}
}, "SL nhập", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  class: "text-end pe-2",
  rowspan: "2",
  style: {"width":"5rem"}
}, "Đơn giá", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  class: "text-end pe-2",
  rowspan: "2",
  style: {"width":"7rem"}
}, "Thành tiền", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "Kết quả kiểm nghiệm", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Phương thức kiểm nghiệm", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"6rem"} }, "Đạt"),
  /*#__PURE__*/_createElementVNode("th", null, "Không đạt")
], -1)
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-start ps-2" }
const _hoisted_20 = {
  key: 0,
  class: "text-end ps-2 pe-2"
}
const _hoisted_21 = {
  key: 1,
  class: "text-end px-1 mb-0"
}
const _hoisted_22 = { class: "text-end pe-2" }
const _hoisted_23 = { class: "text-end pe-2 fw-bolder" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "11",
  class: "text-center py-3 fw-bolder"
}, " Chưa có vật tư trong phiếu nhập. ", -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_CurrencyInputCustom = _resolveComponent("CurrencyInputCustom")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            (!_ctx.forPhieuNhapLe)
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, " SL nhập tối đa "))
              : _createCommentVNode("", true),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _hoisted_15
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.items.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (vatTu, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(vatTu.id), 1),
                  _createElementVNode("td", null, _toDisplayString(vatTu.ten_vat_tu), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(vatTu.ma_vat_tu), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(vatTu.don_vi_tinh ? vatTu.don_vi_tinh : '-'), 1),
                  (!_ctx.forPhieuNhapLe)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.formatCurrencyAndQuantity(vatTu.so_luong_nhap_toi_da)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", null, [
                    (!_ctx.forPhieuNhapLe)
                      ? (_openBlock(), _createBlock(_component_el_input_number, {
                          key: 0,
                          modelValue: vatTu.so_luong_trong_bien_ban,
                          "onUpdate:modelValue": ($event: any) => ((vatTu.so_luong_trong_bien_ban) = $event),
                          type: "number",
                          placeholder: "nhập số lượng",
                          class: "pe-1",
                          onInput: (value) => _ctx.onChangedSoLuongHandler(vatTu, index, value),
                          onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select()))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.formatCurrencyAndQuantity(+vatTu.pivot.so_luong)), 1))
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    (!_ctx.allowEditingDonGia)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatCurrencyAndQuantity(+vatTu.pivot.so_tien)), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_CurrencyInputCustom, {
                          key: 1,
                          modelValue: vatTu.pivot.so_tien,
                          "onUpdate:modelValue": ($event: any) => ((vatTu.pivot.so_tien) = $event),
                          style: {"width":"7rem"},
                          placeholder: "Đơn giá",
                          onInput: ({ value }) => _ctx.handleDonGiaUpdate({
                    index,
                    value,
                  })
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"]))
                  ]),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.formatCurrencyAndQuantity(+vatTu.pivot.so_tien * +vatTu.so_luong_trong_bien_ban, false)), 1),
                  _createElementVNode("td", _hoisted_24, [
                    _createVNode(_component_el_checkbox, {
                      id: "is-dat-checkbox",
                      modelValue: vatTu.is_dat,
                      "onUpdate:modelValue": ($event: any) => ((vatTu.is_dat) = $event),
                      disabled: "",
                      size: "large"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    (!vatTu.is_dat)
                      ? (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: 0,
                          id: "is-dat-checkbox",
                          checked: "",
                          disabled: "",
                          size: "large"
                        }))
                      : (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: 1,
                          id: "is-dat-checkbox",
                          disabled: "",
                          size: "large"
                        }))
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.items[index].phuong_thuc,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.items[index].phuong_thuc) = $event),
                      type: "text",
                      placeholder: "mời nhập",
                      onInput: (value) => _ctx.onChangedPhuongThucHandler(index, value)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                  ])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_26, _hoisted_28))
        ])
      ])
    ])
  ]))
}